<script setup>
import { defineProps } from "vue";

const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
});
</script>

<template>
  <div v-if="props.data.length" class="font-montserrat text-indigo-base">
    <div
      v-for="(row, index) in data"
      :key="row.title"
      class="px-6 py-3"
      :class="{ [secondaryColor ? 'bg-gray-100' : 'bg-gray-30']: index % 2 === 0 }"
    >
      <div class="flex text-base font-semibold">
        <div class="flex-1">
          <div class="flex">
            <p class="flex-1">
              {{ row.title }}
            </p>
            <span class="md:hidden">{{ row.price }}</span>
          </div>
          <p class="mt-1.5 text-sm font-medium">{{ row.description }}</p>
        </div>
        <p class="hidden md:block">{{ row.price }}</p>
      </div>
    </div>
  </div>
</template>
